import Vue from 'vue'

Vue.prototype.$sidebar = new Vue({
  data: () => ({
    show: false
  })
})
